import { render, staticRenderFns } from "./1016.vue?vue&type=template&id=4f7dde23&scoped=true&"
import script from "./1016.vue?vue&type=script&lang=js&"
export * from "./1016.vue?vue&type=script&lang=js&"
import style0 from "./1016.vue?vue&type=style&index=0&id=4f7dde23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7dde23",
  null
  
)

export default component.exports